export default __webpack_public_path__ + "static/media/makmobilize.67382d0d.png";